import React, { useState, useEffect } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./DateRange.css";
import { parseISO } from "date-fns";

const DateRangeComponent = ({ onChange, currentDateRange }) => {
  const [dateRange, setDateRange] = useState([null, null]);
  const [startDate, endDate] = dateRange;

  useEffect(() => {
    if (currentDateRange && currentDateRange[0] && currentDateRange[1]) {
      // const start = new Date(currentDateRange[0]);
      // const end = new Date(currentDateRange[1]);
      // setDateRange([start, end]);
      const start = parseISO(currentDateRange[0]);
      const end = parseISO(currentDateRange[1]);
      if (!isNaN(start) && !isNaN(end)) {
        setDateRange([start, end]);
      } else {
        console.error("Invalid date format in currentDateRange");
      }
    }
  }, [currentDateRange]);

  return (
    <DatePicker
      selectsRange={true}
      startDate={startDate}
      endDate={endDate}
      onChange={(update) => {
        setDateRange(update);
        console.log(update);
        onChange(update);
      }}
      withPortal
      isClearable={true}
      // customInput={<CustomInput />}
    />
  );
};

export default DateRangeComponent;
